import { render, staticRenderFns } from "./ZonePriceTableMobile.vue?vue&type=template&id=6b66f1ca&scoped=true"
import script from "./ZonePriceTableMobile.vue?vue&type=script&lang=js"
export * from "./ZonePriceTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b66f1ca",
  null
  
)

export default component.exports